import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-section',
  template: `
    <div
      *ngFor="let rowField of field.fieldGroup; let i = index"
      class="flex gap-2 mb-2 w-full align-items-center p-2 rounded-md mb-2"
    >
      <ng-container *ngFor="let f of rowField.fieldGroup">
        <formly-field [field]="f" class="flex-1"></formly-field>
      </ng-container>
      <p-button
        type="button"
        icon="pi pi-trash"
        severity="danger"
        [text]="true"
        (click)="remove(i)"
      ></p-button>
    </div>
    <div class="p-2 rounded-md flex justify-center z-1 mb-2">

    <p-button
      type="button"
      [label]="props['addText'] || 'Añadir'"
      [className]=""
      icon="pi pi-plus"
      [text]="true"
      (click)="add()"
    ></p-button>
    
    <div>
  `
})
export class RepeatSectionComponent extends FieldArrayType { }
